
export const CustomerMenuList = [
    {
        title: "Dashboard",
        iconStyle: imagepaths.Dashboard,
        iconActive: imagepaths.DashboardActive,
        to: "/app/customerhome",
        id: "customerhome",
        hasInnerPath: true,
        innerpaths: ["customerhome", "loancalculation"],
    },
    {
        title: "My Profile",
        iconStyle: imagepaths.LeadsIcon,
        iconActive: imagepaths.LeadsIconActive,
        to: "/app/myprofile",
        id: "myprofile",
    },
    {
        title: "Services",
        iconStyle: imagepaths.serviceHomeIcon,
        iconActive: imagepaths.serviceHomeIconActive,
        to: "/app/services",
        id: "services",
        hasInnerPath: true,
        innerpaths: ["services", "loancalculation"],
    },
    {
        title: "My Application",
        iconStyle: imagepaths.greyUserCheckIcon,
        iconActive: imagepaths.greyUserCheckIconActive,
        to: "/app/myapplications",
        id: ["myapplications", "myapplicationqueries", "customerpostsanctiondocs"]
    },
    // {
    //     title: "My Complaints",
    //     iconStyle: imagepaths.complaintsIcon,
    //     iconActive: imagepaths.complaintsIconActive,
    //     to: "/app/mycomplaints",
    //     id: ["mycomplaints"]
    // },
    {
        title: "Terms & Conditions",
        iconStyle: imagepaths.fileCircleCheckIcon,
        iconActive: imagepaths.fileCircleCheckIconActive,
        to: "/app/termsconditions",
        id: "termsconditions",
    },
    {
        title: "Privacy Policy",
        iconStyle: imagepaths.fileTickIcon,
        iconActive: imagepaths.fileTickIconActive,
        to: "/app/privacypolicy",
        id: "privacypolicy",
    },
    {
        title: "Collection Policy",
        iconStyle: imagepaths.fileCancelIcon,
        iconActive: imagepaths.fileCancelIconActive,
        to: "/app/collectionpolicy",
        id: "collectionpolicy",
    },
    {
        title: "RBI Policy",
        iconStyle: imagepaths.rbiIcon,
        iconActive: imagepaths.rbiIcon,
        classChange: "menu-link",
        to: "https://www.rbi.org.in",
        id: "rbipolicy",
    },
];
